@if (copyText.length > 0) {
    <button
        id="copyButton"
        class="btn btn-sm"
        type="button"
        ngbTooltip="{{ 'global.generic.copy' | artemisTranslate }}"
        [cdkCopyToClipboard]="copyText"
        (cdkCopyToClipboardCopied)="onCopyFinished()"
        [class.btn-success]="wasCopied"
    >
        <fa-icon [icon]="faCopy" />
        {{ wasCopied ? ('global.generic.copied' | artemisTranslate) : '' }}
    </button>
}
